import { render, staticRenderFns } from "./discussTheTopic.vue?vue&type=template&id=5345e47e"
import script from "./discussTheTopic.vue?vue&type=script&lang=js"
export * from "./discussTheTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports